import React from 'react';
import EtiquetaEmLoteComponent from '../../histologia/common/etiqueta.lote.component';
import NConformidadeContainer from '../../histologia/common/modais/nconformidade/nconformidade.container';
import { Container, Row, Col } from 'reactstrap';
import DragDropComponente from '@componentes/dragdrog/dragdrop.componente';
import ButtonFloating from '@componentes/button/button-floating.component';
import ImunologiaFiltroPage from './imunologia.filtro.page';
import '../../citologia/content/citologia.styles.css';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../helpers/intlMessage';

const ImunologiaKanbanPage = ({
  etiquetaEmLoteComponentProps,
  nConformidadeContainerProps,
  imunologiaFiltroPageProps,
  dragDropComponente,
  limparFiltros
}) => {
  const intl = useIntl()
  const floatingBtn = [
    {
      className: 'mv-basico-codigo_barras',
      backgroundColor: '#2196f3',
      color: '#ffffff',
      texto:  `${intl.formatMessage({id: 'dashboards.cytology.batchLabels'})}` ,
      onClick: etiquetaEmLoteComponentProps.toggleModalImprimirEtiquetaEmLote
    }
  ];

  return (
    <div className='citologia-page'>
      {etiquetaEmLoteComponentProps.showModalImprimirEtiquetaEmLote && (
        <EtiquetaEmLoteComponent
          showModal={
            etiquetaEmLoteComponentProps.showModalImprimirEtiquetaEmLote
          }
          toggleModal={
            etiquetaEmLoteComponentProps.toggleModalImprimirEtiquetaEmLote
          }
          imprimirEtiquetas={
            etiquetaEmLoteComponentProps.imprimirEtiquetaEmLote
          }
          laminasParaEtiqueta={etiquetaEmLoteComponentProps.laminasParaEtiqueta}
        />
      )}
      {nConformidadeContainerProps.modalOpenNaoConfor && (
        <NConformidadeContainer
          intl={intl}
          open={nConformidadeContainerProps.modalOpenNaoConfor}
          toggle={nConformidadeContainerProps.toggleModalNaoConfor}
          item={nConformidadeContainerProps.itemInModal}
          naoconformidades={nConformidadeContainerProps.naoconformidades}
          usuarioLocal={nConformidadeContainerProps.usuarioLocal}
          callBackConclusaoInclusaoResolucaoNConformidade={
            nConformidadeContainerProps.callBackConclusaoInclusaoResolucaoNConformidade
          }
        />
      )}

      <Container fluid>
        <Row>
          <Col>
            <ImunologiaFiltroPage
              limparFiltro={imunologiaFiltroPageProps.limparFiltro}
              carregando={imunologiaFiltroPageProps.carregando}
              tecnicos={imunologiaFiltroPageProps.tecnicos}
              tecnicoSelecionado={imunologiaFiltroPageProps.tecnicoSelecionado}
              periodoInicial={imunologiaFiltroPageProps.periodoInicial}
              periodoFinal={imunologiaFiltroPageProps.periodoFinal}
              onChangeData={imunologiaFiltroPageProps.onChangeData}
              onChangeTecnico={imunologiaFiltroPageProps.onChangeTecnico}
              onChangeNumeroExame={imunologiaFiltroPageProps.onChangeNumeroExame}
              onChangeLaudo={imunologiaFiltroPageProps.onChangeLaudo}
              onKeyPressNumeroExame={imunologiaFiltroPageProps.onKeyPressNumeroExame}
              onKeyPressLaudo={imunologiaFiltroPageProps.onKeyPressLaudo}
              numeroDoExame={imunologiaFiltroPageProps.numeroDoExame}
              numeroDoExameRef={imunologiaFiltroPageProps.numeroDoExameRef}
              laudoPesquisa={imunologiaFiltroPageProps.laudoPesquisa}
              onClickSearch={imunologiaFiltroPageProps.buscar}
              onClickOrganize={imunologiaFiltroPageProps.organizar}
              sortAsc={imunologiaFiltroPageProps.sortAsc}
              onClickOrdem={imunologiaFiltroPageProps.onClickOrdem}
              periodos={imunologiaFiltroPageProps.periodos}
              periodo={imunologiaFiltroPageProps.periodo}
              onChangePeriodo={imunologiaFiltroPageProps.onChangePeriodo}
              mudarIntervaloPeriodo={imunologiaFiltroPageProps.mudarIntervaloPeriodo}
              onKeyPressData={imunologiaFiltroPageProps.onKeyPressData}
              numeroDoPedido={imunologiaFiltroPageProps.numeroDoPedido}
              onKeyPressNumeroPedido={imunologiaFiltroPageProps.onKeyPressNumeroPedido}
              onChangeNumeroPedido={imunologiaFiltroPageProps.onChangeNumeroPedido}
            />
          </Col>
        </Row>
        <Row>
          <DragDropComponente
            {...imunologiaFiltroPageProps}
            list={dragDropComponente.listaKanbam}
            onDragEndOverride={dragDropComponente.onDragEndOverride}
          />
          <ButtonFloating actions={floatingBtn} />
        </Row>
      </Container>
    </div>
  );
};

export default ImunologiaKanbanPage;



// WEBPACK FOOTER //
// ./src/pages/imunologia/content/imunologia.kanban.page.js